import { Link as MaterialLink, Typography } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import summaryStyles from '../../summary/summarySection/SummaryStyles';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';

export interface IAdditionalDetailsLinkProps {
  setIsExpanded: (value: boolean) => void;
  isExpanded: boolean;
}

const SummaryAdditionalDetailsLink: FunctionComponent<IAdditionalDetailsLinkProps> = ({
  isExpanded,
  setIsExpanded,
}) => {
  const styles = summaryStyles();

  return (
    <MaterialLink
      onClick={() => setIsExpanded(!isExpanded)}
      data-test={'configure:summary:showFullSummary'}
      className={styles.newLink}
    >
      <Typography variant="helpingText">
        {isExpanded ? (
          <>
            <Translation id={'trans__configurator__customise_page_summary_section__hide_full_summary_link'} />
            <ExpandLessIcon className={styles.expandIcon} />
          </>
        ) : (
          <>
            <Translation id={'trans__configurator__customise_page_summary_section__show_full_summary_link'} />
            <ExpandMoreIcon className={styles.expandIcon} />
          </>
        )}
      </Typography>
    </MaterialLink>
  );
};

export default SummaryAdditionalDetailsLink;
